// material
import { alpha, useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export function BaseOptionChartStyle() {
  return {
    '.apexcharts-canvas': {
      '.apexcharts-xaxistooltip': {
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(255, 255, 255, 0.72)',
        border: 0,
        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
        color: '#212B36',
        borderRadius: '12px',
        '&:before': { borderBottomColor: 'transparent' },
        '&:after': { borderBottomColor: 'rgba(255, 255, 255, 0.72)' }
      },
      '.apexcharts-tooltip.apexcharts-theme-light': {
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(255, 255, 255, 0.72)',
        border: 0,
        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
        borderRadius: '12px',
        '& .apexcharts-tooltip-title': {
          border: 0,
          textAlign: 'center',
          fontWeight: 700,
          backgroundColor: 'rgba(145, 158, 171, 0.08)',
          color: '#637381'
        }
      },
      '.apexcharts-legend': {
        padding: 0
      },
      '.apexcharts-legend-series': {
        display: 'flex !important',
        alignItems: 'center'
      },
      '.apexcharts-legend-marker': {
        marginRight: 8
      },
      '.apexcharts-legend-text': {
        lineHeight: '18px',
        textTransform: 'capitalize'
      }
    }
  };
}

export default function BaseOptionChart() {
  const LABEL_TOTAL = {
    show: true,
    label: 'Total',
    color: '#637381',
    fontSize: '0.875rem',
    fontWeight: 600
  };

  const LABEL_VALUE = {
    offsetY: 8,
    color: '#212B36',
    fontSize: '1.5rem',
    fontWeight: 700
  };

  return {
    colors: [
      '#1976d2', // primary
      '#FFC107', // yellow
      '#2196F3', // blue
      '#9C27B0', // violet
      '#4CAF50', // green
      '#F44336'  // red
    ],

    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      foreColor: '#637381',
      fontFamily: 'inherit'
    },

    states: {
      hover: {
        filter: {
          type: 'lighten',
          value: 0.04
        }
      },
      active: {
        filter: {
          type: 'darken',
          value: 0.88
        }
      }
    },

    fill: {
      opacity: 1,
      gradient: {
        type: 'vertical',
        shadeIntensity: 0,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 100]
      }
    },

    dataLabels: { enabled: false },

    stroke: {
      width: 3,
      curve: 'smooth',
      lineCap: 'round'
    },

    grid: {
      strokeDashArray: 3,
      borderColor: '#E0E0E0'
    },

    xaxis: {
      axisBorder: { show: false },
      axisTicks: { show: false }
    },

    markers: {
      size: 0,
      strokeColors: '#FFFFFF'
    },

    tooltip: {
      x: {
        show: false
      }
    },

    legend: {
      show: true,
      fontSize: 13,
      position: 'top',
      horizontalAlign: 'right',
      markers: {
        radius: 12
      },
      fontWeight: 500,
      itemMargin: { horizontal: 12 },
      labels: {
        colors: '#212B36'
      }
    },

    plotOptions: {
      bar: {
        columnWidth: '28%',
        borderRadius: 4
      },
      pie: {
        donut: {
          labels: {
            show: true,
            value: LABEL_VALUE,
            total: LABEL_TOTAL
          }
        }
      },
      radialBar: {
        track: {
          strokeWidth: '100%',
          background: 'rgba(145, 158, 171, 0.08)'
        },
        dataLabels: {
          value: LABEL_VALUE,
          total: LABEL_TOTAL
        }
      },
      radar: {
        polygons: {
          fill: { colors: ['transparent'] },
          strokeColors: '#E0E0E0',
          connectorColors: '#E0E0E0'
        }
      },
      polarArea: {
        rings: {
          strokeColor: '#E0E0E0'
        },
        spokes: {
          connectorColors: '#E0E0E0'
        }
      }
    },

    responsive: [
      {
        breakpoint: 600,
        options: {
          plotOptions: { bar: { columnWidth: '40%' } }
        }
      },
      {
        breakpoint: 960,
        options: {
          plotOptions: { bar: { columnWidth: '32%' } }
        }
      }
    ]
  };
}
